module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6r5n1r-e11ba4b6112add01feacf11378f7784a.svg";